import Header from "./header/header";
import Footer from "./footer/footer";
import NavBar from "./nav/nav-bar";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "./home.css";
import Highcharts, { color } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import histogram from "highcharts/modules/histogram-bellcurve.js";
import Masonry from "react-masonry-css";
import Service from "./webservice/http";
import ClipLoader from "react-spinners/ClipLoader";
import { BiError, BiCommentAdd, BiTaskX } from "react-icons/bi";
import { RiSignalWifiErrorFill } from "react-icons/ri";
import { MdAddIcCall } from "react-icons/md";
import { RiChatVoiceLine } from "react-icons/ri";
import { VscGitPullRequestCreate } from "react-icons/vsc";
import { MdIntegrationInstructions } from "react-icons/md";
import Dropdown from "rsuite/Dropdown";
import { Items } from "./Items";
import { storage } from "./utils/storage";
import { FaFilter } from "react-icons/fa";
import HomeFilter from "./home-filter";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import {
  BiFile,
  BiMoney,
  BiCheckShield,
  BiBulb,
  BiBarChartAlt2,
  BiTrendingUp,
  BiChevronDown,
} from "react-icons/bi";

const Home = ({ loginStatus }) => {
  const history = useHistory();
  const services = new Service();
  const clientName = storage.getItem("client_name");
  const useCase = storage.getItem("usecase");

  // console.log(loginStatus);

  if (!loginStatus) {
    history.push("/login");
    window.location.reload();
  }

  const [collectionFilter, setCollectionFilter] = useState("Team");
  const [complianceFilter, setComplianceFilter] = useState("Team");
  const [expandedStrategyRow, setExpandedStrategyRow] = useState(null);

  const [homeFilterWidth, setHomeFilterWidth] = useState(0);
  const [isHomeFilterOpen, setIsHomeFilterOpen] = useState(false);
  const [homeFilters, setHomeFilters] = useState({});
  const [filterResetKey, setFilterResetKey] = useState(0);

  const changeHomeFilterWidth = () => {
    if (homeFilterWidth === 550) {
      setHomeFilterWidth(0);
      setIsHomeFilterOpen(false);
    } else {
      setHomeFilterWidth(550);
      setIsHomeFilterOpen(true);
    }
  };

  const handleHomeFilterApply = (appliedFilters) => {
    setHomeFilters(appliedFilters);
  };

  const handleHomeFilterReset = () => {
    setHomeFilters({});
    // Increment key to force-remount HomeFilter, resetting all internal dropdown state
    setFilterResetKey((prev) => prev + 1);
  };

  const [collectionLoading, setCollectionLoading] = useState(false);
  const [complianceLoading, setComplianceLoading] = useState(false);
  const [strategyScoreLoading, setStrategyScoreLoading] = useState(false);
  const [trendsLoading, setTrendsLoading] = useState(false);
  const [trendsFilter, setTrendsFilter] = useState("Daily");
  const [cxTrendsLoading, setCxTrendsLoading] = useState(false);
  const [intentLoading, setIntentLoading] = useState(false);
  const [recentReportsLoading, setRecentReportsLoading] = useState(false);

  const [strategyScores, setStrategyScores] = useState([]);
  const [strategyScorePeriod, setStrategyScorePeriod] = useState("");
  const [collectionsData, setCollectionsData] = useState([]);
  const [complianceData, setComplianceData] = useState([]);
  const [trendsData, setTrendsData] = useState({ categories: [], data: [] });
  const [recentReportsData, setRecentReportsData] = useState([]);

  const buildQueryParams = (filters) => {
    const params = new URLSearchParams();
    const mapping = {
      lob: "lob_name",
      manager: "manager_name",
      team_lead: "team_lead_name",
      agent: "agent_name",
      dca_organization: "dca_organization_name",
      dca_manager: "dca_manager_name",
      dca_team: "dca_team_lead_name",
      dca_agent: "dca_agent_name",
      collection_strategy: "collection_strategy",
      product_type: "product_name",
      time_period: "period",
      from_date: "from_date",
      to_date: "to_date",
      bucket_type: "bucket_type",
    };

    // Keys that are display-only and must not be sent to the API
    const displayOnlyKeys = new Set(["bucket_type_label"]);

    for (const [key, value] of Object.entries(filters)) {
      if (displayOnlyKeys.has(key)) continue;
      if (mapping[key] && value) {
        params.append(mapping[key], value);
      } else if (value && !mapping[key]) {
        params.append(key, value);
      }
    }
    const queryString = params.toString().replace(/\+/g, "%20");
    return queryString ? `?${queryString}` : "";
  };

  useEffect(() => {
    setRecentReportsLoading(true);
    const endpoint = `api/call_verification/hierarchy-recent-reports/${buildQueryParams(
      homeFilters,
    )}`;
    const apiService = new Service();
    apiService
      .get(endpoint)
      .then((res) => {
        if (res && res.recent_reports) {
          setRecentReportsData(res.recent_reports);
        } else {
          setRecentReportsData([]);
        }
        setRecentReportsLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setRecentReportsLoading(false);
      });
  }, [homeFilters]);

  useEffect(() => {
    setTrendsLoading(true);
    const endpoint = `api/call_verification/hierarchy-trends-analysis/${buildQueryParams(
      homeFilters,
    )}`;
    const apiService = new Service();
    apiService
      .get(endpoint)
      .then((res) => {
        if (res && res.trends_data) {
          const categories = res.trends_data.map((item) => item.day);
          const data = res.trends_data.map((item) => item.collections);
          setTrendsData({ categories, data });
        } else {
          setTrendsData({ categories: [], data: [] });
        }
        setTrendsLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setTrendsLoading(false);
      });
  }, [homeFilters]);

  useEffect(() => {
    setComplianceLoading(true);
    const endpoint = `api/call_verification/hierarchy-compliance-quality-reports/${buildQueryParams(
      homeFilters,
    )}`;
    const apiService = new Service();
    apiService
      .get(endpoint)
      .then((res) => {
        if (res && res.compliance_quality_reports) {
          setComplianceData(res.compliance_quality_reports);
        } else {
          setComplianceData([]);
        }
        setComplianceLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setComplianceLoading(false);
      });
  }, [homeFilters]);

  useEffect(() => {
    setCollectionLoading(true);

    const endpoint = `api/call_verification/hierarchy-collections-reports/${buildQueryParams(
      homeFilters,
    )}`;

    const apiService = new Service();
    apiService
      .get(endpoint)
      .then((res) => {
        if (res && res.collections_reports) {
          setCollectionsData(res.collections_reports);
        } else {
          setCollectionsData([]);
        }
        setCollectionLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setCollectionLoading(false);
      });
  }, [homeFilters]);

  const [cxTrendsLobData, setCxTrendsLobData] = useState({
    categories: [],
    data: [],
  });
  const [intentAnalysisLobData, setIntentAnalysisLobData] = useState({
    categories: [],
    positive: [],
    negative: [],
  });

  const trendsOptions = {
    chart: {
      type: "column",
      height: "300px",
    },
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      categories: trendsData.categories,
      gridLineWidth: 0,
    },
    yAxis: {
      gridLineColor: "transparent",
      title: {
        text: "Collections",
      },
    },
    plotOptions: {
      column: {
        borderRadius: 5,
      },
    },
    series: [
      {
        name: "Collections",
        data: trendsData.data,
        color: "#7CB5EC",
      },
    ],
  };

  const cxTrendOptionsLob = {
    chart: {
      type: "scatter",
      height: "300px",
    },
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      categories: cxTrendsLobData?.categories || [],
      gridLineWidth: 0,

      title: {
        text: "Date",
      },
    },
    yAxis: {
      gridLineColor: "transparent",
      title: {
        text: "Aggregated Collection Score",
      },
      plotLines: [
        {
          value: 0,
          width: 0,
          color: "#808080",
        },
      ],
    },
    legend: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    plotOptions: {
      series: {
        lineWidth: 1,
      },
    },
    series: [
      {
        data: cxTrendsLobData?.data || [],
        name: "Collection Score",
        color: "#271078",
      },
    ],
  };

  const intentOptions = {
    chart: {
      type: "column",
      height: "300px",
    },
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      categories: intentAnalysisLobData?.categories || [],
      gridLineWidth: 0,
    },
    yAxis: [
      {
        className: "highcharts-color-0",
        title: {
          text: "Positive Intent",
        },
        gridLineColor: "transparent",
      },
      {
        className: "highcharts-color-1",
        opposite: true,
        title: {
          text: "Negative Intent",
        },
        gridLineColor: "transparent",
      },
    ],
    plotOptions: {
      column: {
        borderRadius: 5,
      },
    },
    series: [
      {
        name: "Positive",
        data: intentAnalysisLobData?.positive || [],
        color: "#7CB5EC",
      },
      {
        name: "Negative",
        data: intentAnalysisLobData?.negative || [],
        color: "#434348",
        yAxis: 1,
      },
    ],
  };

  // console.log(useCase);
  const [cxScoreData, setCXScoreData] = useState();
  const [sentimentData, setSentimentData] = useState();
  const [recentCalls, setRecentCalls] = useState(null);
  const [managerComment, setManagerComment] = useState(null);
  const [leadStatus, setLeadStatus] = useState(null);
  const [serviceRequestStatus, setServiceRequestStatus] = useState(null);
  const [pendingTask, setPendingTask] = useState(null);
  const [callBack, setCallBack] = useState(null);

  const [productDetail, setProductDetail] = useState("");
  const [product, setProduct] = useState("");
  const [productType, setProductType] = useState("");
  const [activetab, setActivetab] = useState("Resolutions");

  const [showPassword, setShowPassword] = useState({
    new: false,
    confirm: false,
  });

  useEffect(() => {
    fetchStrategyScores();
  }, [homeFilters]);

  useEffect(() => {
    fetchCxTrendsLob();
  }, [homeFilters]);

  useEffect(() => {
    fetchIntentAnalysisLob();
  }, [homeFilters]);

  const fetchStrategyScores = () => {
    setStrategyScoreLoading(true);
    services
      .get(
        `api/call_verification/collection-strategy-scores/${buildQueryParams(
          homeFilters,
        )}`,
      )
      .then((res) => {
        setStrategyScoreLoading(false);

        const scores = res?.data;

        console.log(res);
        setStrategyScores(scores);

        // date_range can be at top level, inside data[0], or inside collection_strategy_scores
        const dr =
          res?.date_range ||
          res?.data?.[0]?.date_range ||
          res?.data?.[0]?.collection_strategy_scores?.date_range;

        if (dr?.from_date && dr?.to_date) {
          setStrategyScorePeriod(`${dr.from_date} - ${dr.to_date}`);
        } else {
          setStrategyScorePeriod("");
        }
      })
      .catch((err) => {
        setStrategyScoreLoading(false);
        console.error("Strategy Score Fetch Error:", err);
      });
  };

  // console.log(strategyScores);
  const fetchCxTrendsLob = () => {
    setCxTrendsLoading(true);

    services
      .get(`api/report/cx-trend-hierarchy/${buildQueryParams(homeFilters)}`)
      .then((res) => {
        setCxTrendsLoading(false);
        if (res && res.trend_data) {
          const categories = res.trend_data.map((item) => item.date);
          const data = res.trend_data.map((item) => item.avg_cx_score);
          setCxTrendsLobData({ categories, data });
        }
      })
      .catch((err) => {
        setCxTrendsLoading(false);
        console.error("CX Trends LOB Fetch Error:", err);
      });
  };

  const fetchIntentAnalysisLob = () => {
    setIntentLoading(true);

    services
      .get(
        `api/report/intent-analysis-hierarchy/${buildQueryParams(homeFilters)}`,
      )
      .then((res) => {
        setIntentLoading(false);

        let aggregatedData = {};

        // Dates from API daily_intent come as DD-MM-YYYY — store them as-is
        const aggregate = (dailyIntent) => {
          if (!dailyIntent) return;
          dailyIntent.forEach((item) => {
            const key = item.date; // e.g. "24-06-2026"
            if (!aggregatedData[key]) {
              aggregatedData[key] = {
                date: key,
                positive: 0,
                negative: 0,
              };
            }
            aggregatedData[key].positive += item.positive_intent || 0;
            aggregatedData[key].negative += item.negative_intent || 0;
          });
        };

        if (res.team_breakdown && res.team_breakdown.length > 0) {
          res.team_breakdown.forEach((team) => {
            aggregate(team.daily_intent);
          });
        } else if (res.dca_breakdown && res.dca_breakdown.length > 0) {
          res.dca_breakdown.forEach((dca) => {
            aggregate(dca.daily_intent);
          });
        } else if (res.daily_intent) {
          aggregate(res.daily_intent);
        } else if (res.trend_data) {
          aggregate(res.trend_data);
        }

        let categories = [];
        let positive = [];
        let negative = [];

        if (
          res.date_range &&
          res.date_range.from_date &&
          res.date_range.to_date
        ) {
          // date_range uses DD/MM/YYYY — parse it and generate DD-MM-YYYY keys to match daily_intent
          const parseDateUTC = (dateStr) => {
            const parts = dateStr.split("/");
            return new Date(Date.UTC(parts[2], parts[1] - 1, parts[0]));
          };

          const startDate = parseDateUTC(res.date_range.from_date);
          const endDate = parseDateUTC(res.date_range.to_date);

          for (
            let d = new Date(startDate);
            d <= endDate;
            d.setUTCDate(d.getUTCDate() + 1)
          ) {
            const day = String(d.getUTCDate()).padStart(2, "0");
            const month = String(d.getUTCMonth() + 1).padStart(2, "0");
            const year = d.getUTCFullYear();
            const dateKey = `${day}-${month}-${year}`; // DD-MM-YYYY to match API

            categories.push(dateKey);

            if (aggregatedData[dateKey]) {
              positive.push(aggregatedData[dateKey].positive);
              negative.push(aggregatedData[dateKey].negative);
            } else {
              positive.push(0);
              negative.push(0);
            }
          }
        } else {
          const sortedDates = Object.keys(aggregatedData).sort();
          categories = sortedDates;
          positive = sortedDates.map((date) => aggregatedData[date].positive);
          negative = sortedDates.map((date) => aggregatedData[date].negative);
        }

        setIntentAnalysisLobData({ categories, positive, negative });
      })
      .catch((err) => {
        setIntentLoading(false);
        console.error("Intent Analysis Fetch Error:", err);
      });
  };

  histogram(Highcharts);

  useEffect(() => {
    if (storage.getItem("rememberMe") === "true") {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, []);

  function fetchProduct() {
    services.get("api/call/new_call/").then((res) => {
      setProductDetail(res);
    });
  }
  useEffect(() => {
    fetchProduct();
  }, []);

  // console.log(product);
  // console.log("this one", productName);

  /**
   * Fetch homepage data onload
   *
   */
  useEffect(() => {
    fetchFullScriptData();
    fetchRecentCall();
    fetchManagerComment();
    fetchOpportunities();
    fetchServiceRequest();
    fetchPendingTask();
    fetchCallBackRequests();

    fetchCxScoreTrend();
    fetchIntentData();
    var newDate = new Date();

    var sentiment_list = [
      -0.7, -0.7, -0.7, -0.7, -0.7, -0.7, -0.6, -0.6, -0.6, -0.6, -0.5, -0.5,
      -0.5, -0.5, -0.5, -0.5, -0.5, -0.5, -0.5, -0.5, -0.5, -0.5, -0.4, -0.4,
      -0.4, -0.4, -0.4, -0.4, -0.4, -0.4, -0.3, -0.3, -0.3, -0.3, -0.3, -0.3,
      -0.2, -0.2, -0.2, -0.2, -0.1, -0.1, 0.0, 0.0, 0.0, 0.1, 0.1, 0.1, 0.1,
      0.1, 0.2, 0.2, 0.2, 0.2, 0.2, 0.2, 0.3, 0.3, 0.3, 0.3, 0.3, 0.3, 0.3, 0.4,
      0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4,
      0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5,
      0.5, 0.6, 0.6, 0.6, 0.6, 0.6, 0.7, 0.7,
    ];
    setSentimentData(sentiment_list);
  }, []);

  /**
   * Fetch CX Score trend
   */
  function fetchCxScoreTrend() {
    var today = new Date();
    var endDate =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();
    today.setDate(today.getDate() - 180);
    var startDate =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();

    // console.log(start_date, end_date)

    services
      .get(`api/report/${startDate}/${endDate}/cx_score_trend/`)
      .then((res) => {
        // console.log(res);
        // setIsPending(false);
        if (res == "TypeError: Failed to fetch") {
          // setError('Connection Error');
        } else {
          try {
            if (res.code == "token_not_valid") {
              storage.clear();
              history.push("/login");
            }
            var cxData = [];
            var dates = [];
            res.map((item) => {
              cxData.push([item.call_date, item.AverageCX]);
              dates.push(item.call_date);
            });
            setCXScoreData(cxData);
            setDisplayDateCategory(dates);
          } catch (e) {
            // setError(e);
          }
        }
      });
  }

  const [displayDateCategory, setDisplayDateCategory] = useState([]);

  /**
   * set CX Trend chart config
   */
  const cxTrendOptions = {
    chart: {
      type: "scatter",
      height: (6 / 14) * 100 + "%",
      //margin: [70, 50, 60, 80]
    },
    title: {
      text: "",
    },
    subtitle: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      categories: displayDateCategory,
      gridLineWidth: 0,
      //minPadding: 0.2,
      //maxPadding: 0.2,
      //maxZoom: 60,
      type: "datetime",
      dateTimeLabelFormats: {
        // don't display the dummy year
        month: "%e. %b",
        year: "%Y",
      },
      title: {
        text: "Date",
      },
    },
    yAxis: {
      gridLineColor: "transparent",
      // title: {
      //   text:
      //     useCase == "Complaints Management"
      //       ? "Aggregated Complaints Intent "
      //       : "Aggregated Collection Score",
      // },
      //minPadding: 0.2,
      //maxPadding: 0.2,
      //maxZoom: 60,
      plotLines: [
        {
          value: 0,
          width: 0,
          color: "#808080",
        },
      ],
    },
    legend: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    plotOptions: {
      series: {
        lineWidth: 1,
      },
    },
    series: [
      {
        data: cxScoreData,
      },
    ],
  };

  const [intentDateCategory, setIntentDateCategory] = useState(null);
  const [aggregatedCustomerIntentData, setAggregatedCustomerIntentData] =
    useState([]);

  /**
   * Fetch Intent Data for Home Page
   */
  function fetchIntentData() {
    var today = new Date();
    var endDate =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();
    today.setDate(today.getDate() - 180);
    var startDate =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();

    // console.log(start_date, end_date)

    services
      .get(`api/report/${startDate}/${endDate}/customer_intent/`)
      .then((res) => {
        // console.log(res);
        // setIsPending(false);
        if (res == "TypeError: Failed to fetch") {
          // setError('Connection Error');
        } else {
          try {
            if (res.code == "token_not_valid") {
              storage.clear();
              history.push("/login");
            }

            var p = [];
            var n = [];
            var d = [];
            res.intent.map((item) => {
              p.push(item.Positive);
              n.push(item.Negative);
              d.push(item.call_date);
            });
            setAggregatedCustomerIntentData([p, n]);
            setIntentDateCategory(d);
          } catch (e) {
            // setError(e);
          }
        }
      });
  }

  /**
   * Customer Intent
   */
  const aggregatedCustomerIntentOptions = {
    chart: {
      type: "column",
      height: (8 / 19) * 100 + "%",
    },

    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      gridLineWidth: 0,
      categories: intentDateCategory,
    },
    yAxis: {
      // gridLineWidth: 0,
      gridLineColor: "transparent",
    },
    yAxis: [
      {
        className: "highcharts-color-0",
        title: {
          text: "Positive Intent",
        },
      },
      {
        className: "highcharts-color-1",
        opposite: true,
        title: {
          text: "Negative Intent",
        },
      },
    ],

    plotOptions: {
      column: {
        borderRadius: 5,
      },
    },

    series: [
      {
        data: aggregatedCustomerIntentData[0],
        name: "Positive",
      },
      {
        data: aggregatedCustomerIntentData[1],
        name: "Negative",
        yAxis: 1,
      },
    ],
  };

  const [recentCallPending, setRecentCallPending] = useState(true);
  const [recentCallError, setRecentCallError] = useState(null);

  /**
   * Fetch recent 5 Calls from API to display in home page
   */

  function fetchRecentCall() {
    setRecentCallPending(true);
    setRecentCallError(null);
    setRecentCalls(null);
    services.get("api/call/home_page/recent_calls/").then((res) => {
      if (res == "TypeError: Failed to fetch") {
        setRecentCallPending(false);
        setRecentCallError("Connection Error");
      } else {
        try {
          if (res.code == "token_not_valid") {
            storage.clear();
            history.push("/login");
          }
          setRecentCallPending(false);
          setRecentCalls(res);
        } catch (e) {
          setRecentCallError(e);
        }
      }
    });
  }

  // console.log("nono", recentCalls);

  const [managerCommentPending, setManagerCommentPending] = useState(true);
  const [managerCommentError, setManagerCommentError] = useState(null);

  /**
   * Fetch Manager Comment // Call Review to display in home page
   */

  function fetchManagerComment() {
    setManagerComment(null);
    setManagerCommentPending(true);
    setManagerCommentError("");
    services.get("api/call/home_page/managers_comments/").then((res) => {
      if (res == "TypeError: Failed to fetch") {
        setManagerCommentPending(false);
        setManagerCommentError("Connection Error");
      } else {
        try {
          if (res.code == "token_not_valid") {
            storage.clear();
            history.push("/login");
          }
          setManagerCommentPending(false);
          setManagerComment(res);
        } catch (e) {
          setManagerCommentError(e);
        }
      }
    });
  }

  const [opportunityPending, setOpportunityPending] = useState(true);
  const [opportunityError, setOpportunityError] = useState(null);

  function fetchOpportunities() {
    setOpportunityPending(true);
    setOpportunityError("");
    setLeadStatus(null);
    services.get("api/call/home_page/lead_status/").then((res) => {
      if (res == "TypeError: Failed to fetch") {
        setOpportunityPending(false);
        setOpportunityError("Connection Error");
      } else {
        try {
          if (res.code == "token_not_valid") {
            storage.clear();
            history.push("/login");
          }
          setOpportunityPending(false);
          setLeadStatus(res);
        } catch (e) {
          setOpportunityError(e);
        }
      }
    });
  }

  const [serviceRequestPending, setServiceRequestPending] = useState(true);
  const [serviceRequestError, setServiceRequestError] = useState(null);

  function fetchServiceRequest() {
    setServiceRequestError("");
    setServiceRequestPending(true);
    setServiceRequestStatus(null);
    services.get("api/call/home_page/service_request_status/").then((res) => {
      if (res == "TypeError: Failed to fetch") {
        setServiceRequestPending(false);
        setServiceRequestError("Connection Error");
      } else {
        try {
          if (res.code == "token_not_valid") {
            storage.clear();
            history.push("/login");
          }
          setServiceRequestPending(false);
          setServiceRequestStatus(res);
        } catch (e) {
          setServiceRequestError(e);
        }
      }
    });
  }

  const [pendingTaskPending, setPendingTaskPending] = useState(true);
  const [pendingTaskError, setPendingTaskError] = useState(null);

  function fetchPendingTask() {
    setPendingTaskPending(true);
    setPendingTaskError("");
    setPendingTask(null);
    services.get("api/task/recent_tasks/").then((res) => {
      if (res == "TypeError: Failed to fetch") {
        setPendingTaskPending(false);
        setPendingTaskError("Connection Error");
      } else {
        try {
          if (res.code == "token_not_valid") {
            storage.clear();
            history.push("/login");
          }
          setPendingTaskPending(false);
          setPendingTask(res);
        } catch (e) {
          setPendingTaskError(e);
        }
      }
    });
  }

  const [callBackPending, setCallBackPending] = useState(true);
  const [callBackError, setCallBackError] = useState(null);

  function fetchCallBackRequests() {
    setCallBackPending(true);
    setRecentCallError("");
    setCallBack(null);
    services.get("api/call/home_page/call_back_remainders/").then((res) => {
      if (res == "TypeError: Failed to fetch") {
        setCallBackPending(false);
        setCallBackError("Connection Error");
      } else {
        try {
          if (res.code == "token_not_valid") {
            storage.clear();
            history.push("/login");
          }
          setCallBackPending(false);
          setCallBack(res);
        } catch (e) {
          setCallBackError(e);
        }
      }
    });
  }

  const [fullScript, setFullScript] = useState("");
  const [fullScriptPending, setFullScriptPending] = useState(true);
  const [fullScriptError, setFullScriptError] = useState(null);

  function fetchFullScriptData() {
    setFullScriptError("");
    setFullScript("");
    setFullScriptPending(true);
    services
      .get(
        campaignFilter
          ? `api/call_quality/manage_full_script/?title=${campaignFilter}`
          : `api/call_quality/manage_full_script/`,
      )
      .then((res) => {
        if (res == "TypeError: Failed to fetch") {
          setFullScriptPending(false);
          setFullScriptError("Connection Error");
        } else {
          try {
            setFullScript(res);
            setFullScriptPending(false);
            setFullScriptError("");
          } catch {}
        }
      });
  }

  const [nextdrop, setNextdrop] = useState("");

  const fetchnextdropdown = function () {
    let url = `api/call_quality/manage_full_script/`;
    if (!product) return;
    if (product) {
      url = url + `?product_type=${product}`;
    }

    if (productType) {
      url = product
        ? url + `&product=${productType}`
        : url + `?product=${productType}`;
    }
    services.get(url).then((res) => {
      setFullScript(res);
    });
  };

  useEffect(() => {
    fetchnextdropdown();
  }, [product, productType]);

  // console.log(fullScript);

  const [verification, setVerification] = useState("");

  function fetchVerificationData() {
    services.get(`api/pcvc/verification_info/`).then((res) => {
      if (res == "TypeError: Failed to fetch") {
        console.log("failed to fethc");
      } else {
        try {
          setVerification(res);
        } catch {}
      }
    });
  }
  useEffect(() => {
    fetchVerificationData();
  }, []);

  const callInsightRedirect = function (id) {
    if (useCase === "Complaints Management") {
      history.push(`ticket/${id}/complaints-insight`);
    } else {
      history.push(`call/${id}/call-insight`);
    }
  };

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordChnageError, setPasswordChangeError] = useState("");
  const [loaderpass, setLoaderpass] = useState(false);

  const changePassword = async () => {
    setPasswordChangeError("");
    setLoaderpass(true);

    if (!newPassword) {
      setPasswordChangeError("Please enter your new password");
      return;
    }

    if (newPassword.length < 8) {
      setPasswordChangeError(
        "Your password must be at least 8 characters long",
      );
      return;
    }

    if (!confirmPassword) {
      setPasswordChangeError("Please confirm your new password");
      return;
    }

    if (newPassword !== confirmPassword) {
      setPasswordChangeError(
        "Password and confirm password should be the same",
      );
      return;
    }

    const data = {
      new_password: newPassword,
      confirm_password: confirmPassword,
    };

    try {
      const res = await services.post(
        "api/access_control/change_password_first_login/",
        data,
      );

      if (res.code === "token_not_valid") {
        storage.clear();
        history.push("/login");
        return;
      }
      setLoaderpass(false);
      setNewPassword("");
      setConfirmPassword("");
      NotificationManager.success("Success", "Password changed successfully");
      storage.setItem("first_login", "false");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (err) {
      console.error("Password change error:", err);
      setPasswordChangeError(err?.message || "Connection error");
    }
  };

  // const [cancelpasswordchange, setCancelpasswordchange] = useState(null);

  const handelCancel = async () => {
    setNewPassword("");
    setConfirmPassword("");
    setPasswordChangeError("");
    // setCancelpasswordchange(true);
    try {
      const res = await services.post(
        "api/access_control/change_password_first_login_status/",
        {
          password_change: false,
        },
      );

      console.log(res);
      storage.setItem("first_login", "false");
      window.location.reload();
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  // console.log(typeof storage.getItem("first_login"));

  const [CampaignList, setCampaignList] = useState("");
  const [campaignFilter, setCampaignFilter] = useState("");

  function fetchCampaignList() {
    services.get(`api/call_quality/list_campaigns/`).then((res) => {
      if (res == "TypeError: Failed to fetch") {
        console.log("failed to fethc");
      } else {
        try {
          // console.log(res);
          setCampaignList(res?.campaigns);
        } catch {}
      }
    });
  }
  useEffect(() => {
    fetchCampaignList();
  }, []);

  useEffect(() => {
    fetchFullScriptData();
  }, [campaignFilter]);

  // console.log("hyhyhyhyyhny", campaignFilter);

  return (
    <div className="dashboard-body">
      <Header />
      <NavBar />
      <NotificationContainer />
      {storage.getItem("role") !== "Agenth" &&
      storage.getItem("role") !== "Agent Collections" &&
      storage.getItem("role") !== "Agent" &&
      !storage.getItem("role").includes("Agent") ? (
        <section className="page-body" style={{ paddingTop: "15px" }}>
          <button
            onClick={changeHomeFilterWidth}
            title="Global Filters"
            style={{
              position: "fixed",
              transition: "0.5s",
              top: "30%",
              right: homeFilterWidth > 0 ? homeFilterWidth + 8 : 25,
              backgroundColor:
                Object.keys(homeFilters).filter(
                  (k) => k !== "bucket_type_label",
                ).length > 0
                  ? "#271078"
                  : "#F99E52",
              color: "white",
              padding: "10px",
              height: "40px",
              width: "40px",
              zIndex: 2001,
              borderRadius: "10%",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
            }}
          >
            <FaFilter size={18} />
            {Object.keys(homeFilters).filter((k) => k !== "bucket_type_label")
              .length > 0 && (
              <span
                style={{
                  position: "absolute",
                  top: "-4px",
                  right: "-4px",
                  backgroundColor: "#F99E52",
                  color: "#fff",
                  borderRadius: "50%",
                  width: "18px",
                  height: "18px",
                  fontSize: "10px",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {
                  Object.keys(homeFilters).filter(
                    (k) => k !== "bucket_type_label",
                  ).length
                }
              </span>
            )}
          </button>

          <HomeFilter
            key={filterResetKey}
            width={homeFilterWidth}
            changeSideBarWidth={changeHomeFilterWidth}
            onApplyFilter={handleHomeFilterApply}
            onResetFilter={handleHomeFilterReset}
            userRole={storage.getItem("role") || ""}
          />

          {isHomeFilterOpen && (
            <div
              className="backdrop"
              onClick={changeHomeFilterWidth}
              style={{
                position: "fixed",
                inset: 0,
                backgroundColor: "rgba(0,0,0,0.35)",
                zIndex: 1999,
              }}
            />
          )}

          {Object.keys(homeFilters).filter((k) => k !== "bucket_type_label")
            .length > 0 && (
            <div
              style={{
                margin: "0 16px 10px",
                padding: "8px 16px",
                backgroundColor: "#e8e3fa",
                borderLeft: "4px solid #271078",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "12px",
                flexWrap: "wrap",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                {/* Grouping Logic */}
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "700",
                      color: "#271078",
                      marginRight: "4px",
                    }}
                  >
                    Filters (
                    {
                      Object.keys(homeFilters).filter(
                        (k) => k !== "bucket_type_label",
                      ).length
                    }
                    ):
                  </span>
                  {(() => {
                    const formatLabel = (key) => {
                      const CUSTOM_LABELS = {
                        collection_strategy: "Collection Status",
                      };
                      if (CUSTOM_LABELS[key]) return CUSTOM_LABELS[key];
                      const ACRONYMS = { lob: "LOB" };
                      const words = key.replace(/_/g, " ").split(" ");
                      return words
                        .map(
                          (w) =>
                            ACRONYMS[w.toLowerCase()] ||
                            w.charAt(0).toUpperCase() +
                              w.slice(1).toLowerCase(),
                        )
                        .join(" ");
                    };

                    const groups = {
                      Roles: ["lob", "manager", "team_lead", "agent"],
                      DCA: [
                        "dca_organization",
                        "dca_manager",
                        "dca_team",
                        "dca_agent",
                      ],
                      Time: ["time_period", "from_date", "to_date"],
                      Campaign: [
                        "campaign_name",
                        "collection_strategy",
                        "product_type",
                        "bucket_type",
                      ],
                    };

                    return Object.entries(groups).map(([groupName, keys]) => {
                      const activeInGroup = keys.filter((k) => homeFilters[k]);
                      if (activeInGroup.length === 0) return null;

                      // Build a prefix to strip from key labels (e.g. "dca_" for the DCA group)
                      const groupPrefix = groupName.toLowerCase() + "_";

                      return (
                        <div
                          key={groupName}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "#f2effa",
                            border: "1px solid #dcd4f5",
                            borderRadius: "20px",
                            padding: "4px 6px 4px 16px",
                            color: "#271078",
                            fontSize: "13px",
                            fontWeight: "600",
                            gap: "8px",
                          }}
                        >
                          <span>{groupName}</span>
                          <div style={{ display: "flex", gap: "4px" }}>
                            {activeInGroup.map((k) => {
                              // Strip the group prefix (e.g. "dca_") to avoid repeating the group name
                              const displayKey = k.startsWith(groupPrefix)
                                ? k.slice(groupPrefix.length)
                                : k;
                              // For bucket_type, show the human-readable label instead of the raw value
                              const displayValue =
                                k === "bucket_type" &&
                                homeFilters["bucket_type_label"]
                                  ? homeFilters["bucket_type_label"]
                                  : homeFilters[k];
                              return (
                                <span
                                  key={k}
                                  style={{
                                    backgroundColor: "#fff",
                                    border: "1px solid #e0d9f8",
                                    color: "#271078",
                                    borderRadius: "16px",
                                    padding: "3px 10px",
                                    fontSize: "12px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {formatLabel(displayKey)}: {displayValue}
                                </span>
                              );
                            })}
                          </div>
                        </div>
                      );
                    });
                  })()}
                </div>
                <button
                  onClick={handleHomeFilterReset}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#F99E52",
                    fontWeight: "700",
                    fontSize: "12px",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                  }}
                >
                  ✕ Clear All
                </button>
              </div>
            </div>
          )}

          <div className="section-one clearfix" style={{ paddingRight: "0px" }}>
            <div className="container-fluid">
              <Masonry
                breakpointCols={2}
                className="my-masonry-grid gap-3"
                columnClassName="my-masonry-grid_column"
              >
                <div>
                  <div className="assistant" style={{ minHeight: "50px" }}>
                    <div style={{ paddingTop: "20px", paddingLeft: "20px" }}>
                      <label
                        style={{ fontSize: "20px", color: "#271078" }}
                        className=" flex  items-center"
                      >
                        {" "}
                        <span className=" mr-4">
                          <BiFile style={{ fontSize: "25px" }} />{" "}
                        </span>
                        Recent Calls
                      </label>
                    </div>
                    <div style={{ minHeight: "4px", overflow: "auto" }}>
                      <div className="accordion">
                        <div
                          className="call-table"
                          style={{ minHeight: "10px" }}
                        >
                          {recentReportsLoading ? (
                            <div
                              style={{ textAlign: "center", padding: "20px" }}
                            >
                              <ClipLoader color="#2056FF" size="50px" />
                            </div>
                          ) : (
                            <table className="ss">
                              <thead className="">
                                <tr>
                                  <th>
                                    <p className=" text-center">Date</p>
                                  </th>
                                  <th>
                                    <p className=" text-center">Call Id</p>
                                  </th>
                                  <th>
                                    <p className=" text-center">Organization</p>
                                  </th>
                                  <th>
                                    <p className=" text-center text-nowrap">
                                      Kept Rate
                                    </p>
                                  </th>
                                  <th>
                                    <p className=" text-center text-nowrap">
                                      PTP Count
                                    </p>
                                  </th>
                                  <th>
                                    <p className=" text-center">Intent </p>
                                  </th>
                                  <th>
                                    <p className=" text-center">Collected</p>
                                  </th>
                                  <th>
                                    <p className=" text-center">Target </p>
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {(recentReportsData || []).map((row, index) => {
                                  return (
                                    <tr
                                      className="tableRow cursor-pointer"
                                      key={index}
                                      onClick={() =>
                                        callInsightRedirect(row.call_id)
                                      }
                                    >
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.date}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.call_reference}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.organization_name}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.kept_count}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.ptp_count}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className="whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.call_collection_score === 0
                                            ? 0
                                            : row.call_collection_score || "-"}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className="whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.collected}
                                        </a>
                                      </td>

                                      <td>
                                        <a
                                          className="whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.target === 0
                                            ? 0
                                            : row.target || "-"}
                                        </a>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="assistant" style={{ minHeight: "50px" }}>
                    <div
                      style={{
                        paddingTop: "20px",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                      }}
                      className=" flex justify-between items-center"
                    >
                      <label
                        style={{ fontSize: "20px", color: "#271078" }}
                        className=" flex  items-center"
                      >
                        {" "}
                        <span className=" mr-4">
                          <BiMoney style={{ fontSize: "25px" }} />{" "}
                        </span>
                        Collections
                      </label>
                    </div>
                    <div style={{ minHeight: "4px", overflow: "auto" }}>
                      <div className="accordion">
                        <div
                          className="call-table"
                          style={{ minHeight: "10px" }}
                        >
                          {collectionLoading ? (
                            <div
                              style={{ textAlign: "center", padding: "20px" }}
                            >
                              <ClipLoader color="#2056FF" size="50px" />
                            </div>
                          ) : (
                            <table className="ss">
                              <thead className="">
                                <tr>
                                  <th>
                                    <p className=" text-center">Period</p>
                                  </th>
                                  <th>
                                    <p className=" text-center">PTP</p>
                                  </th>
                                  <th>
                                    <p className=" text-center">Kept Rate</p>
                                  </th>

                                  <th>
                                    <p className=" text-center">PTP Count</p>
                                  </th>
                                  <th>
                                    <p className=" text-center">Intent </p>
                                  </th>
                                  <th>
                                    <p className=" text-center">Collected </p>
                                  </th>
                                  <th>
                                    <p className=" text-center">Target </p>
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {(collectionsData || []).map((row, index) => {
                                  return (
                                    <tr
                                      className="tableRow cursor-pointer"
                                      key={index}
                                      onClick={() =>
                                        history.push("/call-list", {
                                          from_date: row.from_date,
                                          to_date: row.to_date,
                                        })
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      <td>
                                        <div
                                          className="whitespace-nowrap"
                                          style={{
                                            color: "black",
                                            display: "flex",
                                            flexDirection: "column",
                                            padding: "4px 0",
                                          }}
                                        >
                                          <span> {row.date_range}</span>
                                        </div>
                                      </td>
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.ptp}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.kept_rate}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.ptp_count}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.call_collection_score}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className="whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.collected}
                                        </a>
                                      </td>

                                      <td>
                                        <a
                                          className="whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.target}
                                        </a>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="assistant" style={{ minHeight: "50px" }}>
                    <div
                      style={{
                        paddingTop: "20px",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                      }}
                      className=" flex justify-between items-center"
                    >
                      <label
                        style={{ fontSize: "20px", color: "#271078" }}
                        className=" flex  items-center"
                      >
                        {" "}
                        <span className=" mr-4">
                          <BiCheckShield style={{ fontSize: "25px" }} />{" "}
                        </span>
                        Compliance & Quality
                      </label>
                    </div>
                    <div style={{ minHeight: "4px", overflow: "auto" }}>
                      <div className="accordion">
                        <div
                          className="call-table"
                          style={{ minHeight: "10px" }}
                        >
                          {complianceLoading ? (
                            <div
                              style={{ textAlign: "center", padding: "20px" }}
                            >
                              <ClipLoader color="#2056FF" size="50px" />
                            </div>
                          ) : (
                            <table className="ss">
                              <thead className="">
                                <tr>
                                  <th>
                                    <p className=" text-center">Period</p>
                                  </th>
                                  <th>
                                    <p className=" text-center">QC</p>
                                  </th>
                                  <th>
                                    <p className=" text-center">AHT</p>
                                  </th>
                                  <th>
                                    <p className=" text-center">Flow Rate</p>
                                  </th>
                                  <th>
                                    <p className=" text-center">Intent</p>
                                  </th>
                                  <th>
                                    <p className=" text-center">Total Calls </p>
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {(complianceData || []).map((row, index) => {
                                  return (
                                    <tr
                                      className="tableRow cursor-pointer"
                                      key={index}
                                      onClick={() =>
                                        history.push("/call-list", {
                                          from_date: row.from_date,
                                          to_date: row.to_date,
                                        })
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      <td>
                                        <div
                                          className="whitespace-nowrap"
                                          style={{
                                            color: "black",
                                            display: "flex",
                                            flexDirection: "column",
                                            padding: "4px 0",
                                          }}
                                        >
                                          <span>{row.date_range}</span>
                                        </div>
                                      </td>
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.qc}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.aht}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.flow_rate}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.call_collection_score}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.total_calls}
                                        </a>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="assistant" style={{ minHeight: "50px" }}>
                    <div
                      style={{
                        paddingTop: "20px",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                      }}
                      className=" flex justify-between items-center"
                    >
                      <label
                        style={{ fontSize: "20px", color: "#271078" }}
                        className=" flex  items-center"
                      >
                        {" "}
                        <span className=" mr-4">
                          <BiBulb style={{ fontSize: "25px" }} />{" "}
                        </span>
                        Collections Strategy Scores
                      </label>
                    </div>
                    <div style={{ minHeight: "4px", overflow: "auto" }}>
                      <div className="accordion">
                        <div
                          className="call-table"
                          style={{ minHeight: "10px" }}
                        >
                          {strategyScoreLoading ? (
                            <div
                              style={{ textAlign: "center", padding: "20px" }}
                            >
                              <ClipLoader color="#2056FF" size="50px" />
                            </div>
                          ) : (
                            (() => {
                              const scores =
                                strategyScores[0]?.collection_strategy_scores
                                  ?.strategy_scores || [];
                              const pqe = scores[0];
                              const pra = scores[1];
                              const pdc = scores[2];

                              const toNum = (v) => parseFloat(v) || 0;
                              const avgScore =
                                scores.length > 0
                                  ? (
                                      (toNum(pqe?.score) +
                                        toNum(pra?.score) +
                                        toNum(pdc?.score)) /
                                      3
                                    ).toFixed(2)
                                  : null;

                              // overall score — use the first row's score or compute average
                              const overallScore =
                                scores.length > 0
                                  ? toNum(pqe?.score) +
                                    toNum(pra?.score) +
                                    toNum(pdc?.score)
                                  : null;

                              return (
                                <>
                                  <table className="ss">
                                    <thead>
                                      <tr>
                                        <th style={{ whiteSpace: "nowrap" }}>
                                          <p className="text-center">Period</p>
                                        </th>
                                        <th title={pqe?.title || "PQE"}>
                                          <p className="text-center">PQE</p>
                                        </th>
                                        <th title={pra?.title || "PRA"}>
                                          <p className="text-center">PRA</p>
                                        </th>
                                        <th title={pdc?.title || "PDC"}>
                                          <p className="text-center">PDC</p>
                                        </th>
                                        <th>
                                          <p className="text-center">Score</p>
                                        </th>
                                        <th>
                                          <p className="text-center">
                                            Avg Score
                                          </p>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {scores.length === 0 ? (
                                        <tr>
                                          <td
                                            colSpan={6}
                                            style={{
                                              textAlign: "center",
                                              padding: "20px",
                                              color: "#aaa",
                                              fontSize: "14px",
                                            }}
                                          >
                                            No strategy score data available.
                                          </td>
                                        </tr>
                                      ) : (
                                        <tr className="tableRow">
                                          <td style={{ whiteSpace: "nowrap" }}>
                                            <span
                                              style={{
                                                fontSize: "13px",
                                              }}
                                            >
                                              {strategyScorePeriod || "—"}
                                            </span>
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <span
                                              style={{
                                                fontSize: "13px",
                                                // fontWeight: "600",
                                              }}
                                            >
                                              {pqe?.score ?? "—"}
                                            </span>
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <span
                                              style={{
                                                fontSize: "13px",
                                                // fontWeight: "600",
                                              }}
                                            >
                                              {pra?.score ?? "—"}
                                            </span>
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <span
                                              style={{
                                                fontSize: "13px",
                                                // fontWeight: "600",
                                              }}
                                            >
                                              {pdc?.score ?? "—"}
                                            </span>
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <span
                                              style={{
                                                fontSize: "13px",
                                                // fontWeight: "600",
                                              }}
                                            >
                                              {overallScore !== null
                                                ? overallScore.toFixed(2)
                                                : "—"}
                                            </span>
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <span
                                              style={{
                                                fontSize: "13px",
                                                // fontWeight: "700",
                                                padding: "2px 8px",
                                              }}
                                            >
                                              {avgScore !== null
                                                ? avgScore
                                                : "—"}
                                            </span>
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>

                                  {/* Legend */}
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "10px 20px",
                                      padding: "10px 14px 14px",
                                      borderTop: "1px dashed #e0e4f0",
                                      marginTop: "4px",
                                    }}
                                  >
                                    {[
                                      {
                                        abbr: "PQE",
                                        label:
                                          "Probing Questions Effectiveness",
                                      },
                                      {
                                        abbr: "PRA",
                                        label: "Payment Resolution Actions",
                                      },
                                      {
                                        abbr: "PDC",
                                        label: "Payment Delay Consequences",
                                      },
                                    ].map(({ abbr, label }) => (
                                      <span
                                        key={abbr}
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: "5px",
                                          fontSize: "13px",
                                          color: "#555",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontWeight: "700",
                                            color: "#271078",
                                            // fontSize: "11.5px",
                                          }}
                                        >
                                          {abbr}
                                        </span>
                                        <span style={{ color: "#aaa" }}>—</span>
                                        {label}
                                      </span>
                                    ))}
                                  </div>
                                </>
                              );
                            })()
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="assistant" style={{ minHeight: "50px" }}>
                    <div
                      style={{
                        paddingTop: "20px",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                      }}
                      className=" flex justify-between items-center"
                    >
                      <label
                        style={{ fontSize: "20px", color: "#271078" }}
                        className=" flex  items-center"
                      >
                        {" "}
                        <span className=" mr-4">
                          <BiBarChartAlt2 style={{ fontSize: "25px" }} />{" "}
                        </span>
                        Trends & Analysis
                      </label>
                    </div>
                    <div
                      style={{
                        minHeight: "300px",
                        overflow: "auto",
                        padding: "20px",
                      }}
                    >
                      {trendsLoading ? (
                        <div style={{ textAlign: "center", padding: "20px" }}>
                          <ClipLoader color="#2056FF" size="50px" />
                        </div>
                      ) : (
                        <HighchartsReact
                          highcharts={Highcharts}
                          options={trendsOptions}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div>
                  <div className="assistant" style={{ minHeight: "50px" }}>
                    <div
                      style={{
                        paddingTop: "20px",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                      }}
                      className=" flex justify-between items-center"
                    >
                      <label
                        style={{ fontSize: "20px", color: "#271078" }}
                        className=" flex  items-center"
                      >
                        {" "}
                        <span className=" mr-4">
                          <BiTrendingUp style={{ fontSize: "25px" }} />{" "}
                        </span>
                        Collection Score Trends
                      </label>
                    </div>
                    <div
                      style={{
                        minHeight: "300px",
                        overflow: "auto",
                        padding: "20px",
                      }}
                    >
                      {cxTrendsLoading ? (
                        <div style={{ textAlign: "center", padding: "20px" }}>
                          <ClipLoader color="#2056FF" size="50px" />
                        </div>
                      ) : (
                        <HighchartsReact
                          highcharts={Highcharts}
                          options={cxTrendOptionsLob}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div>
                  <div className="assistant" style={{ minHeight: "50px" }}>
                    <div
                      style={{
                        paddingTop: "20px",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                      }}
                      className=" flex justify-between items-center"
                    >
                      <label
                        style={{ fontSize: "20px", color: "#271078" }}
                        className=" flex  items-center"
                      >
                        {" "}
                        <span className=" mr-4">
                          <i
                            className="fa fa-bar-chart"
                            aria-hidden="true"
                            style={{ fontSize: "25px" }}
                          ></i>{" "}
                        </span>
                        Intent Analysis
                      </label>
                    </div>
                    <div
                      style={{
                        minHeight: "300px",
                        overflow: "auto",
                        padding: "20px",
                      }}
                    >
                      {intentLoading ? (
                        <div style={{ textAlign: "center", padding: "20px" }}>
                          <ClipLoader color="#2056FF" size="50px" />
                        </div>
                      ) : (
                        <HighchartsReact
                          highcharts={Highcharts}
                          options={intentOptions}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </Masonry>
            </div>
          </div>
        </section>
      ) : (
        <section className="page-body" style={{ paddingTop: "15px" }}>
          <div className="section-one clearfix" style={{ paddingRight: "0px" }}>
            <div className="container-fluid">
              <Masonry
                breakpointCols={2}
                className="my-masonry-grid gap-3"
                columnClassName="my-masonry-grid_column"
              >
                <div>
                  <div className="assistant" style={{ minHeight: "50px" }}>
                    <div style={{ paddingTop: "20px", paddingLeft: "40px" }}>
                      <label
                        style={{ fontSize: "20px", color: "#271078" }}
                        className=" flex  items-center"
                      >
                        {" "}
                        <span className=" mr-4">
                          <i
                            className="fa fa-phone"
                            aria-hidden="true"
                          ></i>{" "}
                        </span>
                        {useCase === "Complaints Management"
                          ? "Recent Tickets"
                          : useCase.includes("Collections")
                            ? "Recent Calls : Collections"
                            : "Recent Calls"}
                      </label>
                    </div>
                    <div style={{ minHeight: "4px", overflow: "auto" }}>
                      <div className="accordion">
                        <div
                          className="call-table"
                          style={{ minHeight: "10px" }}
                        >
                          <table className="ss">
                            {useCase === "Complaints Management" ? (
                              <thead className="">
                                <tr>
                                  <th>
                                    <p className=" text-center">Date</p>
                                  </th>
                                  <th>
                                    <p className=" text-center">Number</p>
                                  </th>
                                  <th>
                                    <p className=" text-center">Product</p>
                                  </th>
                                  <th>
                                    <p className=" text-center">Services</p>
                                  </th>
                                  <th>
                                    <p className=" text-center">Intent</p>
                                  </th>
                                  {/* <th>
                                  <p className=" text-center">Sentiments</p>
                                </th> */}
                                  <th>
                                    <p className="">Status</p>
                                  </th>
                                </tr>
                              </thead>
                            ) : useCase == "Third Party Collection Agency" ? (
                              <thead>
                                <tr>
                                  <th>
                                    <p>Date</p>
                                  </th>
                                  <th>
                                    <p>Customer</p>
                                  </th>

                                  <th className=" whitespace-nowrap">
                                    <p>Call ID </p>
                                  </th>
                                  <th>
                                    <p>Agent</p>
                                  </th>

                                  <th>
                                    <p>Product</p>
                                  </th>
                                  <th>
                                    <p className="whitespace-nowrap">
                                      Sentiments
                                    </p>
                                  </th>

                                  <th>
                                    <p>Intent</p>
                                  </th>
                                  {/* <th>
                                  <p>Recommendations </p>
                                </th> */}
                                </tr>
                              </thead>
                            ) : (
                              <thead>
                                <tr>
                                  <th>
                                    <p>Date</p>
                                  </th>
                                  <th>
                                    <p>Customer</p>
                                  </th>
                                  {useCase ==
                                  "Insurance - PCVC Verification" ? (
                                    <th>
                                      <p>Nemp Id</p>
                                    </th>
                                  ) : (
                                    ""
                                  )}
                                  <th>
                                    <p className=" whitespace-nowrap">
                                      {useCase ==
                                      "Insurance - PCVC Verification"
                                        ? "Product Type"
                                        : "Product"}{" "}
                                    </p>
                                  </th>

                                  <th>
                                    <p>
                                      {useCase ==
                                      "Insurance - PCVC Verification"
                                        ? "Product"
                                        : "Call Type"}{" "}
                                    </p>
                                  </th>
                                  <th>
                                    <p className="whitespace-nowrap">
                                      {useCase ==
                                      "Insurance - PCVC Verification"
                                        ? "Call Status"
                                        : "Sentiments"}
                                    </p>
                                  </th>
                                  {useCase !==
                                  "Insurance - PCVC Verification" ? (
                                    <th>
                                      <p>Intent</p>
                                    </th>
                                  ) : (
                                    ""
                                  )}

                                  <th>
                                    <p>Manual Audit</p>
                                  </th>
                                </tr>
                              </thead>
                            )}

                            <tbody>
                              {recentCalls &&
                                recentCalls?.map((call) => (
                                  <tr
                                    className="tableRow cursor-pointer"
                                    key={call._id}
                                    onClick={() =>
                                      callInsightRedirect(call?._id)
                                    }
                                  >
                                    <td>
                                      <a className=" whitespace-nowrap">
                                        {call?._date}
                                      </a>
                                    </td>
                                    {useCase === "Complaints Management" ? (
                                      <td>{call?._ticket_number}</td>
                                    ) : (
                                      <td>
                                        {call._customer_first_name} &nbsp;{" "}
                                        {call._customer_last_name}
                                      </td>
                                    )}

                                    {useCase !==
                                      "Insurance - PCVC Verification" &&
                                    useCase !== "Complaints Management" ? (
                                      useCase ==
                                      "Third Party Collection Agency" ? (
                                        <td>
                                          {call?._id.slice(0, 5).toUpperCase()}
                                        </td>
                                      ) : (
                                        <td className=" whitespace-nowrap">
                                          {call?._product_name}
                                        </td>
                                      )
                                    ) : (
                                      <td>
                                        <a className="  text-center">
                                          {call.nemp_id || call?._product_type}
                                        </a>
                                      </td>
                                    )}
                                    {useCase ==
                                    "Third Party Collection Agency" ? (
                                      <td>
                                        <a className="  text-center">
                                          {call?._agent}
                                        </a>
                                      </td>
                                    ) : (
                                      ""
                                    )}

                                    {useCase === "Complaints Management" ? (
                                      <td>{call?._product_name}</td>
                                    ) : useCase !==
                                        "Insurance - PCVC Verification" &&
                                      useCase !==
                                        "Third Party Collection Agency" ? (
                                      <td>{call._call_type}</td>
                                    ) : useCase ==
                                      "Third Party Collection Agency" ? (
                                      <td>{call?._product_name}</td>
                                    ) : (
                                      <td>
                                        {call?.prduct_type
                                          .toLowerCase()
                                          .split(" ")
                                          .map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1),
                                          )
                                          .join(" ") || " -"}
                                      </td>
                                    )}

                                    {useCase === "Complaints Management" ? (
                                      <td>
                                        {call._intent > 0 ? (
                                          <p
                                            className="red"
                                            style={{ color: "green" }}
                                          >
                                            <i
                                              className="fa fa-plus-circle"
                                              aria-hidden="true"
                                            />
                                          </p>
                                        ) : (
                                          <p
                                            className="red"
                                            style={{ color: "red" }}
                                          >
                                            <i
                                              className="fa fa-minus-circle"
                                              aria-hidden="true"
                                            />
                                          </p>
                                        )}
                                      </td>
                                    ) : useCase ==
                                      "Third Party Collection Agency" ? (
                                      <td>
                                        {Math.trunc(call?._sentiment * 100)}%
                                      </td>
                                    ) : useCase !==
                                      "Insurance - PCVC Verification" ? (
                                      <td>
                                        {call._sentiment > 0 ? (
                                          <p
                                            className="red"
                                            style={{ color: "green" }}
                                          >
                                            <i
                                              className="fa fa-plus-circle"
                                              aria-hidden="true"
                                            />
                                          </p>
                                        ) : (
                                          <p
                                            className="red"
                                            style={{ color: "red" }}
                                          >
                                            <i
                                              className="fa fa-minus-circle"
                                              aria-hidden="true"
                                            />
                                          </p>
                                        )}
                                      </td>
                                    ) : (
                                      <td>
                                        <p>
                                          {call?._product_name
                                            .toLowerCase()
                                            .split(" ")
                                            .map(
                                              (word) =>
                                                word.charAt(0).toUpperCase() +
                                                word.slice(1),
                                            )
                                            .join(" ") || " -"}
                                        </p>
                                      </td>
                                    )}

                                    {useCase === "Complaints Management" ? (
                                      <td>
                                        <p>{call?._ticket_status}</p>
                                      </td>
                                    ) : useCase ==
                                      "Third Party Collection Agency" ? (
                                      <td>
                                        {Math.abs(
                                          Math.trunc(call?._intent * 100),
                                        )}
                                        %
                                      </td>
                                    ) : useCase !==
                                      "Insurance - PCVC Verification" ? (
                                      <td>
                                        {call._intent > 0 ? (
                                          <p
                                            className="red"
                                            style={{ color: "green" }}
                                          >
                                            <i
                                              className="fa fa-plus-circle"
                                              aria-hidden="true"
                                            />
                                          </p>
                                        ) : (
                                          <p
                                            className="red"
                                            style={{ color: "red" }}
                                          >
                                            <i
                                              className="fa fa-minus-circle"
                                              aria-hidden="true"
                                            />
                                          </p>
                                        )}
                                      </td>
                                    ) : (
                                      <td>
                                        <p
                                          className={`${
                                            call?.call_status == "non-fatal"
                                              ? "text-green-700"
                                              : "text-red-500"
                                          }`}
                                        >
                                          {(call?.call_status &&
                                            call.call_status.replace(
                                              /(?:^|\s|-)\S/g,
                                              function (a) {
                                                return a.toUpperCase();
                                              },
                                            )) ||
                                            "Fatal"}
                                        </p>
                                      </td>
                                    )}

                                    <td className="text-left ">
                                      {call?._call_reviewed ? (
                                        <p className=" flex justify-start font-bold green">
                                          <i
                                            class="fa fa-check-circle"
                                            aria-hidden="true"
                                          ></i>
                                        </p>
                                      ) : (
                                        <p
                                          className=" flex justify-start font-bold
                                         "
                                          style={{ color: "red" }}
                                        >
                                          <i
                                            class="fa fa-times-circle"
                                            aria-hidden="true"
                                          ></i>
                                        </p>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                          {/* {!recentCallPending && (
                          <p className=" text-[12px]  text-red-600">
                            *R,O,E,C means Resolved,Ongoing,Escalation,Closed
                          </p>
                        )} */}
                          {recentCallPending && (
                            <div style={{ textAlign: "center" }}>
                              <ClipLoader color="#2056FF" size="50px" />
                            </div>
                          )}
                          {recentCallError && (
                            <div style={{ textAlign: "center" }}>
                              <p style={{ fontSize: "25px", color: "#FF8520" }}>
                                {recentCallError === "Connection Error" && (
                                  <RiSignalWifiErrorFill />
                                )}
                                {recentCallError !== "Connection Error" && (
                                  <BiError />
                                )}
                                {recentCallError}
                              </p>
                            </div>
                          )}
                          {recentCalls && recentCalls.length === 0 && (
                            <div
                              style={{ fontSize: "20px", textAlign: "center" }}
                            >
                              <MdAddIcCall />
                              <p>No Records Found</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {useCase === "Complaints Management" ? (
                  <div>
                    <div className="assistant" style={{ minHeight: "50px" }}>
                      <div style={{ paddingTop: "20px", paddingLeft: "40px" }}>
                        <label
                          style={{
                            fontSize: "20px",
                            color: "#271078",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {" "}
                          <MdIntegrationInstructions
                            style={{ fontSize: "25px" }}
                          />
                          <span
                            className={`ml-4 flex `}
                            style={{
                              border: "1px solid lightgray",
                              marginTop: "-3px",
                            }}
                          >
                            <button
                              className={`py-1 px-6 border-r border-r-gray-400 ${
                                activetab === "Resolutions"
                                  ? " bg-blue-900 text-white font-normal"
                                  : ""
                              }`}
                              onClick={() => setActivetab("Resolutions")}
                            >
                              Resolutions Tips
                            </button>
                            <button
                              className={`py-1 px-6 ${
                                activetab === "Objection"
                                  ? " bg-blue-900 text-white font-normal"
                                  : ""
                              }`}
                              // style={{ border: "1px solid red" }}
                              onClick={() => setActivetab("Objection")}
                            >
                              Objection Handling
                            </button>
                          </span>
                        </label>
                      </div>

                      <div
                        style={{ height: "350px", overflow: "auto" }}
                        className=" scroll-design "
                      >
                        <div className="accordion">
                          <div
                            className="call-table"
                            style={{ minHeight: "10px" }}
                          >
                            {!fullScriptPending && fullScriptError === "" && (
                              <div className="view-list">
                                <ul
                                  className="clearfix"
                                  // style={{ paddingTop: "20px" }}
                                >
                                  <div
                                    style={{
                                      padding: "5px",
                                      fontSize: "18px",
                                      color: "black",
                                      whiteSpace: "pre-wrap",
                                    }}
                                  >
                                    {activetab == "Resolutions" &&
                                    fullScript.length ? (
                                      fullScript.map((e, i) => (
                                        <div
                                          className={`flex  mt-4 rounded-lg  p-4`}
                                          style={{
                                            border: "1px solid lightgray",

                                            // alignItems: "center",
                                          }}
                                        >
                                          {/* <input type="checkbox" /> */}
                                          <span className=" ">
                                            <div
                                              className=" flex mb-2 py-3 px-4 rounded-lg"
                                              style={{
                                                // border: "1px solid red",
                                                background: "#eef2f5",
                                              }}
                                            >
                                              {useCase ==
                                              "Insurance - PCVC Verification" ? (
                                                <>
                                                  <div className="text-2xl  ">
                                                    <span className="">
                                                      {e?._product_Type
                                                        .toLowerCase()
                                                        .split(" ")
                                                        .map(
                                                          (word) =>
                                                            word
                                                              .charAt(0)
                                                              .toUpperCase() +
                                                            word.slice(1),
                                                        )
                                                        .join(" ")}
                                                    </span>
                                                  </div>{" "}
                                                  <div className=" text-2xl ml-1 mr-1">
                                                    :
                                                  </div>
                                                  <div className="text-2xl">
                                                    <span className="">
                                                      {e?._product
                                                        .toLowerCase()
                                                        .split(" ")
                                                        .map(
                                                          (word) =>
                                                            word
                                                              .charAt(0)
                                                              .toUpperCase() +
                                                            word.slice(1),
                                                        )
                                                        .join(" ")}
                                                    </span>
                                                  </div>
                                                </>
                                              ) : (
                                                <>
                                                  <div className="text-2xl ">
                                                    Title :
                                                    <span className="">
                                                      {e?._title}
                                                    </span>
                                                  </div>{" "}
                                                </>
                                              )}
                                            </div>
                                            <p
                                              className=""
                                              style={{ fontSize: "16px" }}
                                              dangerouslySetInnerHTML={{
                                                __html: e?._script.replace(
                                                  /\n/g,
                                                  "<br />",
                                                ),
                                              }}
                                            />
                                          </span>
                                        </div>
                                      ))
                                    ) : (
                                      <div className=" flex px-12">
                                        <ul className=" list-disc">
                                          <li>
                                            Can you confirm that your issue has
                                            been fully resolved?
                                          </li>
                                          <li>
                                            Are there any remaining questions or
                                            concerns you'd like us to address?
                                          </li>
                                          <li>
                                            Are you comfortable with us closing
                                            this ticket now?
                                          </li>
                                          <li>
                                            Is there any further assistance you
                                            need from us at this time?
                                          </li>
                                          {/* <li>Lorem, ipsum.</li> */}
                                        </ul>
                                      </div>
                                    )}
                                  </div>
                                </ul>
                              </div>
                            )}
                            {fullScriptPending && (
                              <div style={{ textAlign: "center" }}>
                                <ClipLoader color="#2056FF" size="50px" />
                              </div>
                            )}
                            {setFullScriptError === "" && (
                              <div style={{ textAlign: "center" }}>
                                <p
                                  style={{ fontSize: "25px", color: "#FF8520" }}
                                >
                                  {fullScriptError === "Connection Error" && (
                                    <RiSignalWifiErrorFill />
                                  )}
                                  {fullScriptError !== "Connection Error" && (
                                    <BiError />
                                  )}
                                  {fullScriptError}
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="assistant" style={{ minHeight: "50px" }}>
                      <div
                        style={{ paddingTop: "20px", paddingLeft: "40px" }}
                        className=" flex justify-between items-center"
                      >
                        <label
                          style={{
                            fontSize: "20px",
                            color: "#271078",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {" "}
                          <MdIntegrationInstructions
                            style={{ fontSize: "25px" }}
                          />
                          <span className="ml-4" style={{ marginTop: "-3px" }}>
                            {useCase == "Third Party Collection Agency" ||
                            useCase === "Banking Collections PCVC"
                              ? "Collection Script"
                              : "Call Script"}
                          </span>
                        </label>
                        {CampaignList && (
                          <div className="px-6">
                            <select
                              onChange={(e) =>
                                setCampaignFilter(e.target.value)
                              }
                              style={{ border: "1px solid lightgray" }}
                              value={campaignFilter}
                              className="mr-4 px-4 py-1"
                            >
                              <option value="" selected disabled>
                                Select Campaigns
                              </option>

                              {CampaignList &&
                                CampaignList?.map((list) => (
                                  <option key={list} value={list}>
                                    {list}
                                  </option>
                                ))}
                            </select>

                            <button
                              className={`btn btn-danger py-1 ${
                                !campaignFilter
                                  ? "opacity-50 cursor-not-allowed"
                                  : ""
                              }`}
                              disabled={!campaignFilter}
                              style={{
                                // border: "1px solid lightgray",
                                paddingTop: "2px",
                                paddingBottom: "2px",
                                marginBottom: "2px",
                              }}
                              onClick={() => setCampaignFilter("")}
                            >
                              Reset
                            </button>
                          </div>
                        )}
                      </div>
                      {useCase == "Insurance - PCVC Verification" ? (
                        <div className="mt-4" style={{ marginLeft: "40px" }}>
                          <div className=" w-1/2 flex  ">
                            <select
                              onChange={(e) => setProduct(e.target.value)}
                              style={{
                                borderBottom: "1px solid lightgray",
                                marginRight: "15px",
                              }}
                              value={product}
                            >
                              <option value="" selected disabled>
                                Select Product Type
                              </option>
                              {productDetail &&
                                productDetail?.call_type.map((product) => (
                                  <option
                                    key={product.title}
                                    value={product.title}
                                  >
                                    {product.title
                                      .toLowerCase()
                                      .split(" ")
                                      .map(
                                        (word) =>
                                          word.charAt(0).toUpperCase() +
                                          word.slice(1),
                                      )
                                      .join(" ")}
                                  </option>
                                ))}
                            </select>

                            <select
                              onChange={(e) => setProductType(e.target.value)}
                              style={{ borderBottom: "1px solid lightgray" }}
                              value={productType}
                            >
                              <option value="" selected disabled>
                                Select Product
                              </option>

                              {productDetail &&
                                fullScript &&
                                fullScript?.map((product) => (
                                  <option
                                    key={product?._product}
                                    value={product?._product}
                                  >
                                    {product?._product
                                      .toLowerCase()
                                      .split(" ")
                                      .map(
                                        (word) =>
                                          word.charAt(0).toUpperCase() +
                                          word.slice(1),
                                      )
                                      .join(" ")}
                                  </option>
                                ))}
                            </select>
                            {/* <select name="" id="">
                          {nextdrop?.map((e) => (
                            <option>{e?._product}</option>
                          ))}
                        </select> */}

                            <button
                              className="mx-4 bg-blue-900 px-3 text-white  "
                              // style={{ border: "1px solid grey" }}
                              onClick={() => {
                                setNextdrop("");
                                setProduct("");
                                setProductType("");
                              }}
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      <div
                        style={{ height: "350px", overflow: "auto" }}
                        className=" scroll-design "
                      >
                        <div className="accordion">
                          <div
                            className="call-table"
                            style={{ minHeight: "10px" }}
                          >
                            {!fullScriptPending && fullScriptError === "" && (
                              <div className="view-list">
                                <ul
                                  className="clearfix"
                                  // style={{ paddingTop: "20px" }}
                                >
                                  <div
                                    style={{
                                      padding: "5px",
                                      fontSize: "18px",
                                      color: "black",
                                      whiteSpace: "pre-wrap",
                                    }}
                                  >
                                    {fullScript.length ? (
                                      fullScript.map((e, i) => (
                                        <div
                                          className={`flex  mt-4 rounded-lg  p-4
       
        `}
                                          style={{
                                            border: "1px solid lightgray",

                                            // alignItems: "center",
                                          }}
                                        >
                                          {/* <input type="checkbox" /> */}
                                          <span className=" ">
                                            <div
                                              className=" flex mb-2 py-3 px-4 rounded-lg"
                                              style={{
                                                // border: "1px solid red",
                                                background: "#eef2f5",
                                              }}
                                            >
                                              {useCase ==
                                              "Insurance - PCVC Verification" ? (
                                                <>
                                                  <div className="text-2xl  ">
                                                    <span className="">
                                                      {e?._product_Type
                                                        .toLowerCase()
                                                        .split(" ")
                                                        .map(
                                                          (word) =>
                                                            word
                                                              .charAt(0)
                                                              .toUpperCase() +
                                                            word.slice(1),
                                                        )
                                                        .join(" ")}
                                                    </span>
                                                  </div>{" "}
                                                  <div className=" text-2xl ml-1 mr-1">
                                                    :
                                                  </div>
                                                  <div className="text-2xl">
                                                    <span className="">
                                                      {e?._product
                                                        .toLowerCase()
                                                        .split(" ")
                                                        .map(
                                                          (word) =>
                                                            word
                                                              .charAt(0)
                                                              .toUpperCase() +
                                                            word.slice(1),
                                                        )
                                                        .join(" ")}
                                                    </span>
                                                  </div>
                                                </>
                                              ) : (
                                                <>
                                                  <div className="text-2xl ">
                                                    Title :
                                                    <span className="">
                                                      {e?._title}
                                                    </span>
                                                  </div>{" "}
                                                </>
                                              )}
                                            </div>
                                            <p
                                              className=""
                                              style={{ fontSize: "16px" }}
                                              dangerouslySetInnerHTML={{
                                                __html: e?._script.replace(
                                                  /\n/g,
                                                  "<br />",
                                                ),
                                              }}
                                            />
                                          </span>
                                        </div>
                                      ))
                                    ) : (
                                      <div className=" flex justify-center items-center">
                                        <p>No Scripts Found</p>
                                      </div>
                                    )}
                                  </div>
                                </ul>
                              </div>
                            )}
                            {fullScriptPending && (
                              <div style={{ textAlign: "center" }}>
                                <ClipLoader color="#2056FF" size="50px" />
                              </div>
                            )}
                            {setFullScriptError === "" && (
                              <div style={{ textAlign: "center" }}>
                                <p
                                  style={{ fontSize: "25px", color: "#FF8520" }}
                                >
                                  {fullScriptError === "Connection Error" && (
                                    <RiSignalWifiErrorFill />
                                  )}
                                  {fullScriptError !== "Connection Error" && (
                                    <BiError />
                                  )}
                                  {fullScriptError}
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div>
                  <div className="assistant" style={{ minHeight: "50px" }}>
                    <div style={{ paddingTop: "20px", paddingLeft: "40px" }}>
                      <label style={{ fontSize: "20px", color: "#271078" }}>
                        {" "}
                        <i className="fa fa-tasks" aria-hidden="true"></i>{" "}
                        &nbsp;Pending Tasks
                      </label>
                    </div>
                    <div
                      style={{
                        paddingBottom: "10px",
                        minHeight: "40px",
                        overflow: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      <div className="accordion">
                        {pendingTask &&
                          pendingTask.map((task) => (
                            <div
                              key={task.id}
                              className="row dataRow"
                              style={{
                                paddingLeft: "25px",
                                paddingTop: "10px",
                                paddingRight: "25px",
                              }}
                            >
                              <div className="col-md-1">
                                <div
                                  className="star"
                                  style={{ background: "green" }}
                                >
                                  <i
                                    className="fa fa-tasks"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                              </div>

                              <div className="col-md-5">
                                <div className="sat-content">
                                  <h3>{task.title}</h3>
                                  <label>{task.priority} Priority</label>
                                </div>
                              </div>

                              <div
                                className="col-md-3"
                                style={{ fontSize: "16px" }}
                              >
                                <i
                                  style={{ color: "green" }}
                                  className="fa fa-user"
                                  aria-hidden="true"
                                ></i>{" "}
                                &nbsp;
                                <a style={{ color: "black" }}>
                                  {task.created_by__first_name} &nbsp;{" "}
                                  {task.created_by__last_name}
                                </a>
                              </div>

                              <div
                                className="col-md-3"
                                style={{ fontSize: "16px" }}
                              >
                                <i
                                  style={{ color: "red" }}
                                  className="fa fa-calendar-check-o"
                                  aria-hidden="true"
                                ></i>{" "}
                                &nbsp;
                                <a style={{ color: "black" }}>
                                  {task.creation_date.substring(0, 10)}
                                </a>
                              </div>
                            </div>
                          ))}

                        {pendingTaskPending && (
                          <div style={{ textAlign: "center" }}>
                            <ClipLoader color="#2056FF" size="50px" />
                          </div>
                        )}
                        {pendingTaskError && (
                          <div style={{ textAlign: "center" }}>
                            <p style={{ fontSize: "25px", color: "#FF8520" }}>
                              {pendingTaskError === "Connection Error" && (
                                <RiSignalWifiErrorFill />
                              )}
                              {pendingTaskError !== "Connection Error" && (
                                <BiError />
                              )}
                              {pendingTaskError}
                            </p>
                          </div>
                        )}
                        {pendingTask && pendingTask.length === 0 && (
                          <div
                            style={{ fontSize: "20px", textAlign: "center" }}
                          >
                            <BiTaskX />
                            <p>No Pending Task </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="assistant" style={{ minHeight: "50px" }}>
                    <div style={{ paddingTop: "20px", paddingLeft: "40px" }}>
                      <label style={{ fontSize: "20px", color: "#271078" }}>
                        {" "}
                        <i className="fa fa-bell" aria-hidden="true"></i>{" "}
                        {useCase.includes("Collections")
                          ? "Call Review Reminder"
                          : "Callback Reminders"}
                      </label>
                    </div>
                    <div
                      style={{
                        paddingBottom: "10px",
                        minHeight: "40px",
                        overflow: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      <div
                        style={{ paddingLeft: "25px", paddingRight: "25px" }}
                      >
                        {callBack &&
                          callBack.map((cb) => (
                            <div
                              className="row dataRow"
                              style={{ padding: "5px" }}
                            >
                              <div className="col-md-1">
                                <div
                                  className="star"
                                  style={{ background: "blue" }}
                                >
                                  <i
                                    className="fa fa-bell"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                              </div>

                              <div
                                className="col-md-3"
                                style={{ fontSize: "16px" }}
                              >
                                <p style={{ color: "black" }}>
                                  {" "}
                                  <i
                                    style={{ color: "green" }}
                                    className="fa fa-user"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  &nbsp;{cb.customer__first_name}&nbsp;
                                  {cb.customer__last_name}
                                </p>
                                <label>{cb.customer__contact_number}</label>
                              </div>
                              {/* <div className="col-md-1">
                              <div
                                className="star"
                                style={{ background: "blue" }}
                              >
                                hy
                              </div>
                            </div> */}

                              <div
                                className="col-md-3"
                                style={{ fontSize: "16px" }}
                              >
                                <label>{cb.product__title}</label>
                                {/* reason */}
                                Busy with Office work
                              </div>

                              <div
                                className="col-md-3"
                                style={{ fontSize: "16px" }}
                              >
                                <i
                                  style={{ color: "red" }}
                                  className="fa fa-calendar-check-o"
                                  aria-hidden="true"
                                ></i>{" "}
                                &nbsp;
                                <a style={{ color: "black" }}>
                                  {cb.date__date}
                                </a>
                              </div>

                              <div
                                className="col-md-2"
                                style={{ fontSize: "16px" }}
                              >
                                <i
                                  style={{ color: "red" }}
                                  className="fa fa-clock-o"
                                  aria-hidden="true"
                                ></i>{" "}
                                &nbsp;
                                <a style={{ color: "black" }}>
                                  {cb.date__time}
                                </a>
                              </div>
                            </div>
                          ))}
                      </div>

                      {callBackPending && (
                        <div style={{ textAlign: "center" }}>
                          <ClipLoader color="#2056FF" size="50px" />
                        </div>
                      )}
                      {callBackError && (
                        <div style={{ textAlign: "center" }}>
                          <p style={{ fontSize: "25px", color: "#FF8520" }}>
                            {callBackError === "Connection Error" && (
                              <RiSignalWifiErrorFill />
                            )}
                            {callBackError !== "Connection Error" && (
                              <BiError />
                            )}
                            {callBackError}
                          </p>
                        </div>
                      )}
                      {callBack && callBack.length === 0 && (
                        <div style={{ fontSize: "20px", textAlign: "center" }}>
                          <BiCommentAdd />
                          <p>No Records Found</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div>
                  <div className="assistant" style={{ minHeight: "50px" }}>
                    <div style={{ paddingTop: "20px", paddingLeft: "40px" }}>
                      <label style={{ fontSize: "20px", color: "#271078" }}>
                        {" "}
                        <i className="fa fa-comment" aria-hidden="true"></i>
                        &nbsp;
                        {useCase.includes("Collections")
                          ? "Auditors Comments"
                          : "  Manager Comments"}
                      </label>
                    </div>
                    <div
                      className=""
                      style={{
                        paddingBottom: "10px",
                        minHeight: "40px",
                        overflow: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      <div
                        style={{ paddingLeft: "25px", paddingRight: "25px" }}
                      >
                        {managerComment &&
                          managerComment.map((comment) => (
                            <div
                              key={comment.id}
                              className="row dataRow"
                              style={{
                                paddingLeft: "5px",
                                paddingTop: "5px",
                                paddingBottom: "5px",
                                paddingRight: "5px",
                              }}
                            >
                              <div className="col-md-1">
                                <div className="star">
                                  <i
                                    className="fa fa-commenting"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                              </div>
                              <div className="col-md-8">
                                <div className="sat-content">
                                  <h3>
                                    {comment.comment
                                      .toLowerCase()
                                      .split(" ")
                                      .map(
                                        (word) =>
                                          word.charAt(0).toUpperCase() +
                                          word.slice(1),
                                      )
                                      .join(" ")}
                                  </h3>
                                  <label>
                                    {comment.commented_by__first_name}&nbsp;
                                    {comment.commented_by__last_name}
                                  </label>
                                </div>
                              </div>

                              <div className="col-md-3">
                                <i
                                  className="fa fa-calendar"
                                  aria-hidden="true"
                                ></i>
                                &nbsp;
                                <a style={{ fontSize: "15px" }}>
                                  {comment.date__date}
                                </a>
                                <br />
                                <i
                                  className="fa fa-phone-square"
                                  aria-hidden="true"
                                ></i>
                                &nbsp;
                                <a style={{ fontSize: "15px" }}>
                                  {comment.call__call_reference}
                                </a>
                              </div>
                              {/* <div className="col-md-1">
                              <i
                                className="fa fa-info-circle"
                                aria-hidden="true"
                              ></i>
                            </div> */}
                            </div>
                          ))}
                      </div>
                      {managerCommentPending && (
                        <div style={{ textAlign: "center" }}>
                          <ClipLoader color="#2056FF" size="50px" />
                        </div>
                      )}
                      {managerCommentError && (
                        <div style={{ textAlign: "center" }}>
                          <p style={{ fontSize: "25px", color: "#FF8520" }}>
                            {managerCommentError === "Connection Error" && (
                              <RiSignalWifiErrorFill />
                            )}
                            {managerCommentError !== "Connection Error" && (
                              <BiError />
                            )}
                            {managerCommentError}
                          </p>
                        </div>
                      )}
                      {managerComment && managerComment.length === 0 && (
                        <div style={{ fontSize: "20px", textAlign: "center" }}>
                          <BiCommentAdd />
                          <p>No Records Found</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div>
                  <div className="assistant" style={{ minHeight: "50px" }}>
                    <div style={{ paddingTop: "20px", paddingLeft: "40px" }}>
                      <label style={{ fontSize: "20px", color: "#271078" }}>
                        {" "}
                        <i
                          className="fa fa-snowflake-o"
                          aria-hidden="true"
                        ></i>{" "}
                        {useCase === "Complaints Management"
                          ? "Complaints Resolution Score Card"
                          : useCase.includes("Collections")
                            ? "Collections Status"
                            : useCase !== "Insurance - PCVC Verification"
                              ? "Opportunity Status"
                              : "Verification Status"}
                      </label>
                    </div>
                    <div style={{ minHeight: "40px", overflow: "auto" }}>
                      <div className="accordion">
                        <div
                          className="call-table"
                          style={{ minHeight: "10px" }}
                        >
                          {useCase !== "Insurance - PCVC Verification" ? (
                            <table className="ss">
                              <thead>
                                <tr>
                                  <th>
                                    <p>Reference</p>
                                  </th>
                                  <th>
                                    <p>Customer</p>
                                  </th>
                                  <th>
                                    <p>Product</p>
                                  </th>
                                  <th>
                                    <p>Status</p>
                                  </th>
                                  {useCase !==
                                  "Insurance - PCVC Verification" ? (
                                    <th>
                                      <p>Sentiments</p>
                                    </th>
                                  ) : (
                                    <th>
                                      <p>-</p>
                                    </th>
                                  )}
                                </tr>
                              </thead>

                              <tbody>
                                {leadStatus &&
                                  leadStatus.map((lead) => (
                                    <tr key={lead._id} className="tableRow">
                                      <td>
                                        <a>{lead.call__call_reference}</a>
                                      </td>
                                      <td>
                                        {lead.call__customer__first_name}&nbsp;
                                        {lead.call__customer__last_name}
                                      </td>
                                      <td>
                                        <a>{lead.product__title}</a>
                                      </td>
                                      <td>{lead.review_status}</td>
                                      <td>
                                        {lead.call__customer_sentiment > 0 ? (
                                          <p
                                            className="red"
                                            style={{ color: "green" }}
                                          >
                                            <i
                                              className="fa fa-plus-circle"
                                              aria-hidden="true"
                                            />
                                          </p>
                                        ) : (
                                          <p
                                            className="red"
                                            style={{ color: "red" }}
                                          >
                                            <i
                                              className="fa fa-minus-circle"
                                              aria-hidden="true"
                                            />
                                          </p>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          ) : (
                            <table className="ss">
                              <thead>
                                <tr>
                                  <th>
                                    <p>Date</p>
                                  </th>
                                  <th>
                                    <p>Customer</p>
                                  </th>
                                  <th>
                                    <p>NEMP Id</p>
                                  </th>
                                  <th>
                                    <p>Product</p>
                                  </th>

                                  <th>
                                    <p>Status</p>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {verification &&
                                  verification.map((lead) => (
                                    <tr key={lead._id} className="tableRow">
                                      <td>
                                        <a>{lead?.call_date}</a>
                                      </td>
                                      <td>{lead?.customer}</td>
                                      <td>
                                        <a>{lead?.nemp_id}</a>
                                      </td>
                                      <td>
                                        {lead.product
                                          .toLowerCase()
                                          .split(" ")
                                          .map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1),
                                          )
                                          .join(" ")}
                                      </td>
                                      <td>
                                        {lead?.call_status[0].toUpperCase() +
                                          lead?.call_status.slice(1)}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          )}
                        </div>
                        {opportunityPending && (
                          <div style={{ textAlign: "center" }}>
                            <ClipLoader color="#2056FF" size="50px" />
                          </div>
                        )}
                        {opportunityError && (
                          <div style={{ textAlign: "center" }}>
                            <p style={{ fontSize: "25px", color: "#FF8520" }}>
                              {opportunityError === "Connection Error" && (
                                <RiSignalWifiErrorFill />
                              )}
                              {opportunityError !== "Connection Error" && (
                                <BiError />
                              )}
                              {opportunityError}
                            </p>
                          </div>
                        )}
                        {leadStatus && leadStatus.length === 0 && (
                          <div
                            style={{ fontSize: "20px", textAlign: "center" }}
                          >
                            <VscGitPullRequestCreate />
                            <p>No Records Found</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {useCase !== "Insurance - PCVC Verification" &&
                useCase !== "Complaints Management" ? (
                  <div>
                    <div className="assistant" style={{ minHeight: "50px" }}>
                      <div style={{ paddingTop: "20px", paddingLeft: "40px" }}>
                        <label style={{ fontSize: "20px", color: "#271078" }}>
                          {" "}
                          <i
                            className="fa fa-superpowers"
                            aria-hidden="true"
                          ></i>{" "}
                          &nbsp;Service Request Status
                        </label>
                      </div>
                      <div style={{ minHeight: "40px", overflow: "auto" }}>
                        <div className="accordion">
                          <div
                            className="call-table"
                            style={{ minHeight: "10px" }}
                          >
                            <table className="ss">
                              <thead>
                                <tr>
                                  <th>
                                    <p>Reference</p>
                                  </th>
                                  <th>
                                    <p>Customer</p>
                                  </th>
                                  <th>
                                    <p>Product</p>
                                  </th>
                                  <th>
                                    <p>Status</p>
                                  </th>
                                  <th>
                                    <p>Sentiments</p>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {serviceRequestStatus &&
                                  serviceRequestStatus.map((sr) => (
                                    <tr key={sr._id} className="tableRow">
                                      <td>
                                        <a>{sr.call__call_reference}</a>
                                      </td>
                                      <td>
                                        {sr.call__customer__first_name}&nbsp;
                                        {sr.call__customer__last_name}
                                      </td>
                                      <td>
                                        <a>{sr.product__title}</a>
                                      </td>
                                      <td>{sr.review_status}</td>
                                      <td>
                                        {sr.call__customer_sentiment > 0 ? (
                                          <p
                                            className="red"
                                            style={{ color: "green" }}
                                          >
                                            <i
                                              className="fa fa-plus-circle"
                                              aria-hidden="true"
                                            />
                                          </p>
                                        ) : (
                                          <p
                                            className="red"
                                            style={{ color: "red" }}
                                          >
                                            <i
                                              className="fa fa-minus-circle"
                                              aria-hidden="true"
                                            />
                                          </p>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                          {serviceRequestPending && (
                            <div style={{ textAlign: "center" }}>
                              <ClipLoader color="#2056FF" size="50px" />
                            </div>
                          )}
                          {serviceRequestError && (
                            <div style={{ textAlign: "center" }}>
                              <p style={{ fontSize: "25px", color: "#FF8520" }}>
                                {serviceRequestError === "Connection Error" && (
                                  <RiSignalWifiErrorFill />
                                )}
                                {serviceRequestError !== "Connection Error" && (
                                  <BiError />
                                )}
                                {serviceRequestError}
                              </p>
                            </div>
                          )}
                          {serviceRequestStatus &&
                            serviceRequestStatus.length === 0 && (
                              <div
                                style={{
                                  fontSize: "20px",
                                  textAlign: "center",
                                }}
                              >
                                <VscGitPullRequestCreate />
                                <p>No Records Found</p>
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {useCase !== "Insurance - PCVC Verification" ? (
                  <div>
                    <div className="assistant" style={{ height: "450px" }}>
                      <div style={{ paddingTop: "20px", paddingLeft: "40px" }}>
                        <label style={{ fontSize: "20px", color: "#271078" }}>
                          {" "}
                          <i
                            className="fa fa-area-chart"
                            aria-hidden="true"
                          ></i>{" "}
                          {useCase === "Complaints Management"
                            ? "Complaints Intent Trends"
                            : useCase === "Third Party Collection Agency" ||
                                useCase === "Banking Collections PCVC" ||
                                useCase.includes("Collections")
                              ? "Collection Score Trends "
                              : "CX Score Trend"}{" "}
                          &nbsp;
                        </label>
                      </div>
                      <div
                        style={{
                          height: "390px",
                          overflow: "auto",
                          overflowX: "hidden",
                        }}
                      >
                        <div className="accordion">
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={cxTrendOptions}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {useCase !== "Insurance - PCVC Verification" ? (
                  <div>
                    <div className="assistant" style={{ height: "450px" }}>
                      <div style={{ paddingTop: "20px", paddingLeft: "40px" }}>
                        <label style={{ fontSize: "20px", color: "#271078" }}>
                          {" "}
                          <i
                            className="fa fa-bar-chart"
                            aria-hidden="true"
                          ></i>{" "}
                          {useCase === "Complaints Management"
                            ? "Complaints Intent Analysis"
                            : useCase === "Third Party Collection Agency" ||
                                useCase === "Banking Collections PCVC"
                              ? "Collections : Intent Analysis"
                              : "Intent Analysis"}{" "}
                          &nbsp;
                        </label>
                      </div>
                      <div
                        style={{
                          height: "390px",
                          overflow: "auto",
                          overflowX: "hidden",
                        }}
                      >
                        <div className="accordion">
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={aggregatedCustomerIntentOptions}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </Masonry>
            </div>
          </div>
        </section>
      )}
      {storage.getItem("first_login") === "true" ? (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 text-2xl">
          <div
            className="bg-white p-6 rounded-lg shadow-lg"
            style={{ width: "600px", height: "auto" }}
          >
            <div className="flex justify-center items-center">
              <h4 className="font-bold mb-4">Change Your Password</h4>
            </div>
            <p className="text-gray-600 mb-4 text-2xl">
              For security reasons, we recommend changing the password set by
              our backend team.
            </p>

            <div className="mb-6 relative">
              <label className="block text-2xl font-medium text-gray-700">
                New Password:
              </label>
              <input
                type={showPassword.new ? "text" : "password"}
                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm h-14 px-4 pr-12"
                style={{ border: "1px solid lightgray" }}
                autocomplete="new-password"
                value={newPassword}
                onChange={(e) => {
                  setPasswordChangeError("");
                  setNewPassword(e.target.value);
                }}
              />
              <button
                type="button"
                className="absolute right-4 top-16 transform -translate-y-1/2 text-gray-600"
                onClick={() =>
                  setShowPassword({ ...showPassword, new: !showPassword.new })
                }
              >
                <i
                  className={`fa ${
                    !showPassword.new ? "fa-eye-slash" : "fa-eye"
                  }`}
                  aria-hidden="true"
                ></i>
              </button>
            </div>

            <div className="mb-6 relative">
              <label className="block text-2xl font-medium text-gray-700">
                Confirm Password:
              </label>
              <input
                type={showPassword.confirm ? "text" : "password"}
                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm h-14 px-4 pr-12"
                style={{ border: "1px solid lightgray" }}
                autoComplete="confirm-password"
                value={confirmPassword}
                onChange={(e) => {
                  setPasswordChangeError("");
                  setConfirmPassword(e.target.value);
                }}
              />
              <button
                type="button"
                className="absolute right-4  top-16 transform -translate-y-1/2 text-gray-600"
                onClick={() =>
                  setShowPassword({
                    ...showPassword,
                    confirm: !showPassword.confirm,
                  })
                }
              >
                <i
                  className={`fa ${
                    !showPassword.confirm ? "fa-eye-slash" : "fa-eye"
                  }`}
                  aria-hidden="true"
                ></i>
              </button>
            </div>
            <div class="">
              <span class="mb-0" style={{ color: "red" }}>
                {passwordChnageError}
              </span>
            </div>

            <div className="flex justify-end popup-footer">
              <button
                className="btn"
                style={{ padding: "8px" }}
                onClick={() => {
                  handelCancel();
                }}
              >
                Cancel
              </button>
              <button
                className={`btn btn Save flex items-center justify-center ${
                  loaderpass ? "cursor-not-allowed opacity-50" : ""
                }`}
                style={{ padding: "8px" }}
                onClick={changePassword}
              >
                {loaderpass && <ClipLoader size={16} color="white" />}
                <span className=" ml-2">Confirm</span>
              </button>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      <Footer />
    </div>
  );
};

export default Home;
